/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.DebtorReceiptFilter = (function() {

    /**
     * Namespace DebtorReceiptFilter.
     * @exports DebtorReceiptFilter
     * @namespace
     */
    var DebtorReceiptFilter = {};

    DebtorReceiptFilter.DebtorReceiptFilterModel = (function() {

        /**
         * Properties of a DebtorReceiptFilterModel.
         * @memberof DebtorReceiptFilter
         * @interface IDebtorReceiptFilterModel
         * @property {string|null} [invoiceNo] DebtorReceiptFilterModel invoiceNo
         * @property {string|null} [debtorName] DebtorReceiptFilterModel debtorName
         * @property {string|null} [dateFrom] DebtorReceiptFilterModel dateFrom
         * @property {string|null} [dateTo] DebtorReceiptFilterModel dateTo
         * @property {string|null} [sortColumn] DebtorReceiptFilterModel sortColumn
         * @property {string|null} [sortOrder] DebtorReceiptFilterModel sortOrder
         * @property {number|null} [pageIndex] DebtorReceiptFilterModel pageIndex
         * @property {number|null} [pageSize] DebtorReceiptFilterModel pageSize
         * @property {string|null} [quoteNo] DebtorReceiptFilterModel quoteNo
         */

        /**
         * Constructs a new DebtorReceiptFilterModel.
         * @memberof DebtorReceiptFilter
         * @classdesc Represents a DebtorReceiptFilterModel.
         * @implements IDebtorReceiptFilterModel
         * @constructor
         * @param {DebtorReceiptFilter.IDebtorReceiptFilterModel=} [p] Properties to set
         */
        function DebtorReceiptFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DebtorReceiptFilterModel invoiceNo.
         * @member {string|null|undefined} invoiceNo
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        DebtorReceiptFilterModel.prototype.invoiceNo = null;

        /**
         * DebtorReceiptFilterModel debtorName.
         * @member {string|null|undefined} debtorName
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        DebtorReceiptFilterModel.prototype.debtorName = null;

        /**
         * DebtorReceiptFilterModel dateFrom.
         * @member {string|null|undefined} dateFrom
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        DebtorReceiptFilterModel.prototype.dateFrom = null;

        /**
         * DebtorReceiptFilterModel dateTo.
         * @member {string|null|undefined} dateTo
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        DebtorReceiptFilterModel.prototype.dateTo = null;

        /**
         * DebtorReceiptFilterModel sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        DebtorReceiptFilterModel.prototype.sortColumn = null;

        /**
         * DebtorReceiptFilterModel sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        DebtorReceiptFilterModel.prototype.sortOrder = null;

        /**
         * DebtorReceiptFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        DebtorReceiptFilterModel.prototype.pageIndex = null;

        /**
         * DebtorReceiptFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        DebtorReceiptFilterModel.prototype.pageSize = null;

        /**
         * DebtorReceiptFilterModel quoteNo.
         * @member {string|null|undefined} quoteNo
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        DebtorReceiptFilterModel.prototype.quoteNo = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * DebtorReceiptFilterModel _invoiceNo.
         * @member {"invoiceNo"|undefined} _invoiceNo
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        Object.defineProperty(DebtorReceiptFilterModel.prototype, "_invoiceNo", {
            get: $util.oneOfGetter($oneOfFields = ["invoiceNo"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorReceiptFilterModel _debtorName.
         * @member {"debtorName"|undefined} _debtorName
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        Object.defineProperty(DebtorReceiptFilterModel.prototype, "_debtorName", {
            get: $util.oneOfGetter($oneOfFields = ["debtorName"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorReceiptFilterModel _dateFrom.
         * @member {"dateFrom"|undefined} _dateFrom
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        Object.defineProperty(DebtorReceiptFilterModel.prototype, "_dateFrom", {
            get: $util.oneOfGetter($oneOfFields = ["dateFrom"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorReceiptFilterModel _dateTo.
         * @member {"dateTo"|undefined} _dateTo
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        Object.defineProperty(DebtorReceiptFilterModel.prototype, "_dateTo", {
            get: $util.oneOfGetter($oneOfFields = ["dateTo"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorReceiptFilterModel _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        Object.defineProperty(DebtorReceiptFilterModel.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorReceiptFilterModel _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        Object.defineProperty(DebtorReceiptFilterModel.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorReceiptFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        Object.defineProperty(DebtorReceiptFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorReceiptFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        Object.defineProperty(DebtorReceiptFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorReceiptFilterModel _quoteNo.
         * @member {"quoteNo"|undefined} _quoteNo
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @instance
         */
        Object.defineProperty(DebtorReceiptFilterModel.prototype, "_quoteNo", {
            get: $util.oneOfGetter($oneOfFields = ["quoteNo"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified DebtorReceiptFilterModel message. Does not implicitly {@link DebtorReceiptFilter.DebtorReceiptFilterModel.verify|verify} messages.
         * @function encode
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @static
         * @param {DebtorReceiptFilter.IDebtorReceiptFilterModel} m DebtorReceiptFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DebtorReceiptFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.invoiceNo != null && Object.hasOwnProperty.call(m, "invoiceNo"))
                w.uint32(10).string(m.invoiceNo);
            if (m.debtorName != null && Object.hasOwnProperty.call(m, "debtorName"))
                w.uint32(18).string(m.debtorName);
            if (m.dateFrom != null && Object.hasOwnProperty.call(m, "dateFrom"))
                w.uint32(26).string(m.dateFrom);
            if (m.dateTo != null && Object.hasOwnProperty.call(m, "dateTo"))
                w.uint32(34).string(m.dateTo);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(42).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(50).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(56).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(64).int32(m.pageSize);
            if (m.quoteNo != null && Object.hasOwnProperty.call(m, "quoteNo"))
                w.uint32(74).string(m.quoteNo);
            return w;
        };

        /**
         * Encodes the specified DebtorReceiptFilterModel message, length delimited. Does not implicitly {@link DebtorReceiptFilter.DebtorReceiptFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @static
         * @param {DebtorReceiptFilter.IDebtorReceiptFilterModel} message DebtorReceiptFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DebtorReceiptFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DebtorReceiptFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {DebtorReceiptFilter.DebtorReceiptFilterModel} DebtorReceiptFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DebtorReceiptFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.DebtorReceiptFilter.DebtorReceiptFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.invoiceNo = r.string();
                    break;
                case 2:
                    m.debtorName = r.string();
                    break;
                case 3:
                    m.dateFrom = r.string();
                    break;
                case 4:
                    m.dateTo = r.string();
                    break;
                case 5:
                    m.sortColumn = r.string();
                    break;
                case 6:
                    m.sortOrder = r.string();
                    break;
                case 7:
                    m.pageIndex = r.int32();
                    break;
                case 8:
                    m.pageSize = r.int32();
                    break;
                case 9:
                    m.quoteNo = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a DebtorReceiptFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof DebtorReceiptFilter.DebtorReceiptFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {DebtorReceiptFilter.DebtorReceiptFilterModel} DebtorReceiptFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DebtorReceiptFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return DebtorReceiptFilterModel;
    })();

    return DebtorReceiptFilter;
})();

module.exports = $root;
